import { cn } from '@shadcn/lib/utils';
import { Card as ShadcnCard, CardContent } from '@shadcn/ui/card';
import React from 'react';

const customBackgroundClasses = {
  default: 'bg-white',
  muted: 'bg-secondary-200',
  transparent: 'bg-transparent',
};

export function Card({ background = 'default', className, contentClassName, children, ...props }: CardProps) {
  return (
    <ShadcnCard className={cn(customBackgroundClasses[background], className)} {...props}>
      <CardContent className={contentClassName}>{children}</CardContent>
    </ShadcnCard>
  );
}

export type CardProps = React.ComponentProps<typeof ShadcnCard> & {
  readonly background?: 'default' | 'muted' | 'transparent';
  readonly contentClassName?: string;
};
